import React from 'react'

export const pieChartData = [
    {name: 'J', amt: 24},
    {name: 'F', amt: 18},
    {name: 'M', amt: 22},
    {name: 'A', amt: 17},
    {name: 'M', amt: 25},
    {name: 'J', amt: 12},
    {name: 'J', amt: 21},
];

export const latestPostList = [
    {
        image: 'http://via.placeholder.com/500x330',
        title: "5 DIY tips to use in kitchen",
        description: "Lorem ipsum dolor sit amet, consectetur adipisicing elit...",
        date: "28 Oct, 2016",
        color: "bg-primary"
    },

    {
        image: 'http://via.placeholder.com/500x330',
        title: "Flowers which keep you healthy",
        description: "There are many variations of passages of Lorem Ipsum...",
        date: "27 Feb, 2017",
        color: "bg-danger"
    },
    {
        image: 'http://via.placeholder.com/500x330',
        title: "Top 5 beaches in the world",
        description: "It is a long established fact that a reader will be distract...",
        date: "24 Feb, 2017",
        color: "bg-info"
    },

];

export const data1 = [
    {name: 'Let A', uv: 30, pv: 24, amt: 20},
    {name: 'Let B', uv: 50, pv: 13, amt: 21},
    {name: 'Let C', uv: 47, pv: 98, amt: 29},
    {name: 'Let D', uv: 60, pv: 39, amt: 20},
    {name: 'Let E', uv: 40, pv: 48, amt: 28},
    {name: 'Let F', uv: 43, pv: 38, amt: 20},
    {name: 'Let G', uv: 30, pv: 43, amt: 20},
    {name: 'Let F', uv: 50, pv: 38, amt: 20},
];
export const appNotification = [

    {
        id: 1,
        title: "Invitation",
        desc: [<a href="javascript:void(0)">Stella</a>, " has sent you an invitation to join project ",
            <a href="javascript:void(0)">Mouldifi</a>],
        image: 'http://via.placeholder.com/256x256'
    },
    {
        id: 2,
        title: "Message",
        desc: [<a href="javascript:void(0)">Jeson Born</a>, " Need your help on ",
            <a href="javascript:void(0)">Jambo</a>],
        image: 'http://via.placeholder.com/256x256'
    },
    {
        id: 3,
        title: "Invitation",
        desc: [<a href="javascript:void(0)">Guptil</a>, " has sent you an invitation to join project ",
            <a href="javascript:void(0)">Mouldifi</a>],
        image: 'http://via.placeholder.com/256x256'
    },
    {
        id: 4,
        title: "Invitation",
        desc: [<a href="javascript:void(0)">Alex Dolgove</a>, " has sent you an invitation to join project ",
            <a href="javascript:void(0)">Mouldifi</a>],
        image: 'http://via.placeholder.com/256x256'
    },
];

export const announcementsNotification = [
    {
        id: 5,
        title: "Invitation",
        desc: [<a href="javascript:void(0)">Alex Dolgove</a>, " has sent you an invitation to join project ",
            <a href="javascript:void(0)">Mouldifi</a>],
        image: 'http://via.placeholder.com/256x256'
    },
    {
        id: 6,
        title: "Message",
        desc: [<a href="javascript:void(0)">Jeson Born</a>, " Need your help on ",
            <a href="javascript:void(0)">Jambo</a>],
        image: 'http://via.placeholder.com/256x256'
    }, {
        id: 7,
        title: "Invitation",
        desc: [<a href="javascript:void(0)">Stella</a>, " has sent you an invitation to join project ",
            <a href="javascript:void(0)">Mouldifi</a>],
        image: 'http://via.placeholder.com/256x256'
    },
    {
        id: 8,
        title: "Invitation",
        desc: [<a href="javascript:void(0)">Guptil</a>, " has sent you an invitation to join project ",
            <a href="javascript:void(0)">Mouldifi</a>],
        image: 'http://via.placeholder.com/256x256'
    },
];

export const products = [
    {
        image: 'http://via.placeholder.com/600x400',
        title: "Up unpacked friendly",
        description: "Contrary to popular belief, Lorem Ipsum is not simply random text.",
        mrp: 250,
        offerPrice: 200
    },
    {
        image: 'http://via.placeholder.com/600x400',
        title: "It allowance prevailed",
        description: "It is a long established fact that a reader will be distracted",
        mrp: 250,
        offerPrice: 200
    },
    {
        image: 'http://via.placeholder.com/600x400',
        title: "Case read they must",
        description: "There are many variations of passages of Lorem Ipsum available",
        mrp: 250,
        offerPrice: 200
    },
    {
        image: 'http://via.placeholder.com/600x400',
        title: "Too carriage attended",
        description: "The standard chunk of Lorem Ipsum used since the 1500s",
        mrp: 250,
        offerPrice: 200
    },
];


export const marketingData = [
    {
        id: 1,
        name: 'Facebook Ads',
        desc: '63 Likes, 387 Shares',
        icon: 'facebook',
        color: 'bg-indigo lighten-1',
        budget: 570,
        growth: 20
    },

    {
        id: 2,
        name: 'Twitter Ads',
        desc: '43 Likes, 545 Shares',
        icon: 'twitter',
        color: 'bg-light-blue accent-2',
        budget: 811,
        growth: -5
    },

    {
        id: 3,
        name: 'Instagram',
        desc: '83 Follows, 210 Likes',
        icon: 'instagram',
        color: 'bg-brown lighten-1',
        budget: 685,
        growth: 20
    },

    {
        id: 4,
        name: 'LinkedIn',
        desc: '23 Shares, 764 Likes',
        icon: 'linkedin',
        color: 'bg-light-blue darken-3',
        budget: 868,
        growth: 25
    },

];




// WEBPACK FOOTER //
// ./app/routes/dashboard/routes/Default/data.js